import apiClient from '../../api/apiClient';
import { Role } from '../users/usersSlice';

// Rol servisi
const rolesService = {
  // Tüm rolleri getir
  getRoles: async (): Promise<Role[]> => {
    console.log("Fetching roles...");
    try {
      // Doğrudan '/roles' endpoint'ini kullan
      const response = await apiClient.get('/roles');
      console.log("Roles API response:", response);
      
      // Yanıt bir dizi değilse, boş dizi döndür
      if (!Array.isArray(response)) {
        console.error("API response is not an array:", response);
        return [];
      }
      
      return response;
    } catch (error) {
      console.error("Error fetching roles:", error);
      return []; // Hata durumunda boş dizi döndür
    }
  }
};

export default rolesService;